// extracted by mini-css-extract-plugin
module.exports = {"container":"TOPMovies_container__2ZzD1"};